import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../styles/max-container-width/max-container-width.style';
import {
  mediumPaddingHorizontalBox,
  smallPaddingVerticalBox,
} from '../view-style';

export default StyleSheet.create({
  text: {
    flexWrap: 'wrap',
  },
  view: {
    ...smallPaddingVerticalBox,
    ...mediumPaddingHorizontalBox,
    ...maxContainerWidthStyle,
  },
});
